<template>
  <div class="mockup-preview-dynamic">
    <!-- Preview Mask -->
    <slot name="stores"></slot>

    <div class="mockup-preview-dynamic__renders">
      <div class="mockup__input">
        <label class="mockup__btn" :for="`previewMask${timestamp}`"
          >Upload Mask</label
        >
        <input
          type="file"
          v-show="false"
          :id="`previewMask${timestamp}`"
          ref="previewMask"
          @change="setPreviewMask"
          accept=".png, .jpg, .jpeg"
        />
      </div>
      <div class="mockup-preview-dynamic__renders-mask-zoom">
        <preview-mask :current="current" />

        <slot name="zoom"></slot>
      </div>
    </div>

    <preview-effects
      :current="current"
      :timestamp="timestamp"
      :image-width="imageWidth"
      :image-height="imageHeight"
    />
    <preview-colors
      :current="current"
      :timestamp="timestamp"
      :image-width="imageWidth"
      :image-height="imageHeight"
      :colors="colors"
      @setColors="(r) => $emit('setColors', r)"
      @addColor="(r) => $emit('addColor', r)"
    />
  </div>
</template>

<script>
import PreviewColors from "./preview-colors/PreviewColors.vue";
import PreviewEffects from "./preview-effects/PreviewEffects.vue";
import PreviewMask from "./preview-mask/PreviewMask.vue";

export default {
  components: {
    PreviewColors,
    PreviewEffects,
    PreviewMask,
  },
  props: {
    current: Object,
    colors: Array,
  },
  data() {
    return {
      timestamp: new Date().getTime(),
      imageWidth: null,
      imageHeight: null,
    };
  },
  watch: {
    current: {
      handler() {
        this.setImageSize();
      },
      deep: true,
    },
  },
  methods: {
    setPreviewMask() {
      const file = this.$refs.previewMask.files[0];
      if (!!file) this.current.addPreviewMask({ file, order: 0 });
    },
    setImageSize() {
      if (!!this.imageWidth && !!this.imageHeight) return;
      const i = new Image();
      i.onload = () => (
        (this.imageWidth = i.width), (this.imageHeight = i.height)
      );
      i.src = this.current.previewMask.src;
    },
  },
  mounted() {
    this.setImageSize();
  },
};
</script>

<style lang="scss" scoped>
.mockup-preview-dynamic {
  display: grid;
  // grid-template-columns: 1fr auto auto;
  padding: 0 6px 6px;
  gap: 6px;

  &__renders-mask-zoom {
    display: grid;
    grid-template-columns: auto auto;
    gap: 6px;
  }
}
</style>
